import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import AddButton from '../Components/AddButton';
import AppointmentLine from '../Components/Appointment/AppointmentLine';
import CloseButton from '../Components/CloseButton';
import ErrorAlert from '../Components/ErrorAlert';
import { Col, Row } from 'react-bootstrap';
import PatientInfoDisplayer from '../Components/Patient/PatientInfoDisplayer';
import { handleResponseError } from '../Commons/errorHandler';
import { getAppointmentsByPatientId } from '../Hooks/appointmentHook';

function PatientAppointments() {
  const [errorsList, setErrorsList] = useState([]);
  const [patientId, setPatientId] = useState(-1);
  const [currentPatient, setCurrentPatient] = useState({});
  const [patientAppointments, setPatientAppointments] = useState([]);

  let navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location == null || location.state == null || location.state.patient == null) {
      setErrorsList(["Patient not selected"]);
    } else {
      setCurrentPatient(location?.state?.patient);
    }
    setCurrentPatient(location?.state?.patient);
  }, [location?.state?.patient]);


  const getPatientAppointments = () => {
    if (currentPatient?.id == null || currentPatient?.id < 1) {
      return;
    }
    let successHandler = (response) => {
      setPatientAppointments(response.data)
      return response.data;
    }
    return getAppointmentsByPatientId(currentPatient?.id, successHandler, (error) => { return handleResponseError(error, setErrorsList) })
  }

  useEffect(() => {
    // getCurrentPatient();
    getPatientAppointments();
  }, [currentPatient]);

  return (
    <div>
      <h1>Patients Appointments</h1>
      <CloseButton onClickHandler={() => navigate("/patients")} />
      <ErrorAlert errors={errorsList} hide={errorsList.length === 0} />
      {/*
      <div>
        <input type="text" placeholder="Search" className="mb-2" onChange={onSearchChange} />
      </div>
      */}
      <Row>
        <Col>
          <h3>
            Patient
            {
              patientAppointments?.length === 0
              && <span style={{ color: "red" }}>(First Appointment)</span>
            }
          </h3>
          <PatientInfoDisplayer patient={currentPatient} />
        </Col>
      </Row>
      <hr />
      <AddButton onClickHandler={() => { navigate('/addAppointment', { state: { patient: currentPatient, referrer: "patient/appointments" } }); }} />
      {
        patientAppointments?.map((appointment) => {
          return (
            <AppointmentLine key={appointment.id} appointment={appointment} patient={currentPatient} />
          );
        })
      }
    </div>
  );
}

export default PatientAppointments